import { debounce, map, sum, min, throttle } from "lodash";

declare const jQuery: any;
const $ = jQuery;

export function initStretchText(): void
{
	$(".stretch-text-parent").each(function () {
		initStretchTextParent(this);
	});
}

export function initStretchTextItem($text, $parent, respectBounds = true, maxScaleRatio?: number): void
{
	$text = $($text);
	$parent = $($parent);
	const stretch = () => stretchContainer($text, $parent, respectBounds, maxScaleRatio); 
	stretch();
	$(window).on("resize load", throttle(stretch, 100));
}

function initStretchTextParent($parent): void
{
	$parent = $($parent);
	const $text = $parent.find(".stretch-text");
	if ($text.length === 0)
	{
		console.warn("stretch-text error: no .stretch-text inside .stretch-text-parent:", $parent[0]);
		return;
	}
	const respectBounds: boolean = $text.hasClass("stretch-text-respect-bounds");
	const maxScaleRatio: number|undefined = parseFloat($text.attr("data-max-scale-ratio")) || undefined;
	initStretchTextItem($text, $parent, respectBounds, maxScaleRatio);
}

function stretchContainer($text, $parent, respectBounds: boolean, maxScaleRatio?: number): void
{
	$text.css("transform", "none");
	$parent.css("height", "");
	const textWidth: number = $text.outerWidth();
	if (!textWidth)
	{
		console.warn("stretch-text error: no textWidth");
		return;
	}
	const parentWidth: number = ($parent.width() || 0) - (parseInt($parent.css("padding-left") || 0, 10) + parseInt($parent.css("padding-right") || 0, 10));
	if (!parentWidth)
	{
		console.warn("stretch-text error: no parentWidth");
		return;
	}
	let scaleRatio: number = parentWidth / textWidth;
	if (maxScaleRatio && scaleRatio > maxScaleRatio)
	{
		scaleRatio = maxScaleRatio;
	}
	const setRatio = (scaleRatio: number): void => {
		let transformValue: string = `scale(${scaleRatio})`;
		$text.css({ transform: transformValue });
		const oldParentHeight: number = $parent.height();
		const newParentHeight: number = oldParentHeight * scaleRatio;
		$parent.css({ height: newParentHeight });
		if (respectBounds)
		{
			const translateX: number = getTranslateXValueForRespectBounds($text, $parent);
			if (translateX)
			{
				transformValue = `translateX(${translateX}px) ${transformValue}`;
				$text.css({ transform: transformValue });
			}
		}
	};

	setRatio(scaleRatio);

	$text.trigger("stretched", {
		$text,
		$parent,
		ratio: scaleRatio,
		setRatio: (correctedRatio: number) => {
			$text.css("transform", "none");
			$parent.css("height", "");
			setRatio(correctedRatio);
		}
	});
}

function getTranslateXValueForRespectBounds($text, $parent): number
{	
	const text: HTMLElement = $text[0];
	const textRect = text.getBoundingClientRect();
	const parent: HTMLElement = $parent[0];
	const parentRect = parent.getBoundingClientRect();
	let textLeft: number = textRect.left;

	// correct for right-hand side overspill
	const rightSpill: number = textRect.right - parentRect.right;
	let translateX = 0;
	if (rightSpill > 0)
	{
		textLeft -= rightSpill;
		translateX = -rightSpill;
	}

	//fixme test:
	// correct for left-hand side overspill
	const leftSpill: number = parentRect.left - textLeft;
	if (leftSpill > 0)
	{
		translateX -= leftSpill;
	}
	return translateX;
}

if (!window["iw"])
{
	window["iw"] = {};
}

window["iw"].stretchText = initStretchTextItem;
